import { render, staticRenderFns } from "./TheTabsItem.vue?vue&type=template&id=79a49014"
import script from "./TheTabsItem.vue?vue&type=script&lang=js"
export * from "./TheTabsItem.vue?vue&type=script&lang=js"
import style0 from "./TheTabsItem.vue?vue&type=style&index=0&id=79a49014&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports